import { AxiosResponse } from "axios";
import axiosInstance from "./base";
import { TTrainingType } from "../shared/types/training.type";

export class TrainingType {

    static getTrainingTypes(trainer?: string): Promise<AxiosResponse<TTrainingType[]>> {
        return axiosInstance.get(`training_types?trainer=${trainer}&itemsPerPage=1000`)
    }

    static createTrainingTypes(data: Partial<TTrainingType>): Promise<AxiosResponse<TTrainingType>> {
        return axiosInstance.post('training_types', data)
    }
    static updateTrainingTypes(data: Partial<TTrainingType>): Promise<AxiosResponse<TTrainingType>> {
        return axiosInstance.patch(`training_types/${data.id}`, data, {
            headers: {
                'Content-Type': 'application/merge-patch+json',
            }
        })
    }

    static delete(id: number) {
        return axiosInstance.delete(`training_types/${id}`)

    }


}